import ImageOptimizer from '@/components/image-optimizer';
import { convertToHyphen, extractTextOnly, slugify } from '@/lib/utils';
import { ArticleEntity } from '@/services/types/article.type';
import ReviewArrow from '@/svg/review_arrow.svg';
import Link from 'next/link';

export default function BlogHeader({
  id,
  title,
  thumbPath,
  board,
  content,
}: ArticleEntity) {
  return (
    <Link
      href={
        '/' +
        convertToHyphen(board.type.replace('_training', '')) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="border-stroke-white flex flex-col overflow-hidden rounded-2xl bg-white shadow-[0_0_20px_0_rgba(183,196,221,0.5)]">
        <div className="flex gap-4">
          <div className="desktop:h-[171px] desktop:aspect-[372/171] relative aspect-[335/154] w-full flex-shrink-0">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
            />
          </div>
        </div>
        <div className="desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between desktop:gap-2 desktop:px-6 desktop:py-8 flex flex-col gap-2 px-5 py-6">
          <div className="text-level-2 typo-24 desktop:typo-28 desktop:leading-snug line-clamp-2 leading-snug font-extrabold">
            {title}
          </div>
          <div className="desktop:typo-20 text-level-3 typo-18 desktop:leading-relaxed line-clamp-2 leading-relaxed font-semibold">
            {extractTextOnly(content)}
          </div>
          <div className="text-main-blue typo-16 desktop:typo-18 desktop:pt-7 flex items-center gap-1 pt-4 font-bold">
            내용보기 <ReviewArrow />
          </div>
        </div>
      </div>
    </Link>
  );
}
